import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import { ReceiptData } from './ReceiptsPreview';
import Receipt from '../Receipt';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    taxReceiptId: string;
}>;

type State = {
    taxReceiptId: number;
    receipt: ReceiptData | null;
    isLoading: boolean;
}

export default class AccountInvoice extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            taxReceiptId: 0,
            receipt: null,
            isLoading: false,
        };

        this.emailReceipt = this.emailReceipt.bind(this);
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Invoice" />
            <div className="form-row py-2 d-print-none">
                <div className="col-auto ml-auto">
                    <button role="button" className="btn btn-primary" onClick={() => confirm("Email Receipt PDF?") && this.emailReceipt()}>Email Receipt</button>
                    &nbsp;
                    <button role="button" className="btn btn-primary" onClick={() => { window.print() }}>Print Receipt</button>
                </div>
            </div>
            {this.state.receipt && <Receipt receipt={this.state.receipt} />}
        </React.Fragment>
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let taxReceiptId = parseInt(this.props.match.params.taxReceiptId) || 0;
        this.requestReceipt(taxReceiptId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let taxReceiptId = parseInt(nextProps.match.params.taxReceiptId) || 0;

        if (this.state.receipt && this.state.taxReceiptId != taxReceiptId) {
            this.requestReceipt(taxReceiptId);
        }
    }

    public emailReceipt() {
        if (this.state.taxReceiptId > 0&& this.state.isLoading == false) {
            this.setState({ isLoading: true });
            fetchApi(`api/Account/EmailReceipt/${this.state.taxReceiptId}`, {}, 'POST')
                .then(() => {
                    alert("Receipt Successfully Emailed!");
                })
                .catch(() => {
                    alert("Unable to email receipt!");
                })
                .finally(() => {
                    this.setState({ isLoading: false });
                });
        }
    }

    public requestReceipt(taxReceiptId: number) {
        fetchApi(`api/Account/TaxReceipt/${taxReceiptId}`)
            .then((receipt: ReceiptData) => {
                this.setState({ receipt, taxReceiptId });
            });
    }
}
